import { Component, OnInit } from "@angular/core";
import { SortDescriptor } from "@progress/kendo-data-query";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { IMyTask } from "src/app/interfaces";
import { LogClass, Logger, LogMethod } from "src/app/logger";
import { NavigationService } from "src/app/services";
import { CookieFacade } from "src/app/services/cookie.facade";
import { StepFacade } from "src/app/step/services/step.facade";

@LogClass({ source: "MyTasksPageComponent" })
@Component({
    selector: "circ-my-tasks-page",
    templateUrl: "./my-tasks-page.component.html",
    styleUrls: ["./my-tasks-page.component.scss"],
    standalone: false
})
export class MyTasksPageComponent implements OnInit {
  public filterActions = [
    { id: "Waiting", displayName: "status_step_Waiting" },
    { id: "InProgress", displayName: "status_step_InProgress" },
    { id: "Canceled", displayName: "status_step_Canceled" },
    { id: "Finished", displayName: "status_step_Finished" },
    { id: "Errored", displayName: "status_step_Errored" }
  ];
  private selectedFilterSubject = new BehaviorSubject(this.filterActions[1].id);
  public selectedFilter$ = this.selectedFilterSubject.asObservable();
  public tasks$: Observable<IMyTask[]>;
  public initialSort: SortDescriptor[];
  public isLoading = true;
  private logger: Logger;

  constructor(
    private cookies: CookieFacade,
    private navigate: NavigationService,
    private stepFacade: StepFacade
  ) {
    this.initialSort = this.cookies.getTaskSort([
      {
        field: "dueDate",
        dir: "desc"
      }
    ]) as SortDescriptor[];
  }

  @LogMethod()
  ngOnInit(): void {
    const allTasks$ = this.stepFacade
      .getMySteps()
      .pipe(tap(() => (this.isLoading = false)));
    this.tasks$ = combineLatest([allTasks$, this.selectedFilter$]).pipe(
      map(([myTasks, status]) => {
        return myTasks.filter((task) => task.stepStatus === status);
      })
    );
  }

  @LogMethod()
  public onSortChange(sort: SortDescriptor[]): void {
    this.cookies.setTaskSort(sort);
  }

  @LogMethod()
  public onFilterClick(filterId: string): void {
    this.selectedFilterSubject.next(filterId);
  }
  @LogMethod()
  @LogMethod()
  public onCellClick(dataItem: IMyTask): void {
    this.navigate.toCirculation(dataItem.circulationId);
  }
}
